// import modules
const modules = require.context('./', true, /\.json$/);

const locale = {
  translation: {}
};

modules.keys().forEach((path) => {
  const parts = path.split('/').slice(1);
  let currentLevel = locale.translation;

  parts.forEach((part, index) => {
    const isFile = part.endsWith('.json');
    const key = isFile ? part.replace('en_', '').replace('.json', '') : part;

    if (isFile) {
      // currentLevel[key] = modules(path).default;
      currentLevel[key] = require(`${path}`);
    } else {
      if (!currentLevel[key]) currentLevel[key] = {};
      currentLevel = currentLevel[key];

    }
  });
});

export default locale;
